/**
 * IDI-246: what completing or reopening a job changes, read the way the
 * confirm lists it. The server does the work (complete_job / reopen_job);
 * these only preview it from the job as a GET returned it (status already
 * derived, so an auto-completed work order is not open).
 */
import { formatJobNumber } from './displayId';
import { woDisplayNumber } from './workOrderEdit';

const CLOSED = new Set(['completed', 'complete', 'cancelled', 'canceled']);

function jobWorkOrders(job) {
  const camel = Array.isArray(job?.workOrders) ? job.workOrders : null;
  const snake = Array.isArray(job?.work_orders) ? job.work_orders : null;
  if (snake && snake.length) return snake;
  return camel || snake || [];
}

export function isJobCompleted(job) {
  const s = String(job?.status || '').trim().toLowerCase();
  return s === 'completed' || s === 'complete';
}

/** The work orders complete_job will close: every one not already closed. */
export function openWorkOrders(job) {
  return jobWorkOrders(job).filter((wo) => wo && !CLOSED.has(String(wo.status || '').trim().toLowerCase()));
}

/** The work orders reopen_job will restore: the ones the job closed. */
export function reopenWorkOrders(job) {
  const closed = Array.isArray(job?.completedWorkOrders) ? job.completedWorkOrders : [];
  const ids = new Set(closed.map((r) => (r && typeof r === 'object' ? r.id : r)).filter(Boolean));
  return jobWorkOrders(job).filter((wo) => wo && ids.has(wo.id) && wo.completedReason === 'job');
}

/** "number · title" (the number is left out when the work order has none). */
function workOrderRowLabel(wo) {
  const title = (typeof wo?.title === 'string' && wo.title.trim()) || wo?.type || wo?.name || 'Work order';
  return [woDisplayNumber(wo), title].filter(Boolean).join(' \u00b7 ');
}

/** Confirm rows for one or several jobs; with several each starts with its job number. */
export function confirmRows(jobs, pick) {
  const several = jobs.length > 1;
  const rows = [];
  jobs.forEach((job) => {
    pick(job).forEach((wo) => {
      const label = workOrderRowLabel(wo);
      rows.push({ key: `${job.id}:${wo.id}`, label: several ? `${formatJobNumber(job)} \u00b7 ${label}` : label });
    });
  });
  return rows;
}
